import * as yup from 'yup';
import { aceite, tipoRegime } from './utils/rulesByKey';

export const RegimeTributarioAssistidoSchema = yup.object({
  ...tipoRegime,
  ...aceite,
});

export const RegimeTributarioAssistidoValues = {
  tipoRegime: '',
  aceite: false,
};
